// MINDSTATE - Shipping info box on PDP
(function () {
  'use strict';

  var CUTOFF_HOUR = 17;

  function nowWarsaw() {
    return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Warsaw' }));
  }
  function isFriday(d) { return d.getDay() === 5; }
  function isWeekday(d) { var x = d.getDay(); return x >= 1 && x <= 5; }

  function getMessage() {
    var now = nowWarsaw();
    var cutoff = new Date(now); cutoff.setHours(CUTOFF_HOUR, 0, 0, 0);
    var before = now < cutoff;
    var friday = isFriday(now);
    var weekday = isWeekday(now);

    if (weekday && before && !friday) return 'Zamów do 17:00 - odbierz jutro';
    if (friday && before)             return 'Zamów teraz - wysyłka jeszcze dziś';
    if (weekday && !before && !friday) return 'Zamów teraz - wysyłka jutro';
    return 'Zamów teraz - wysyłka w poniedziałek';
  }

  function update() {
    var nodes = document.querySelectorAll('[data-ms-shipping] .ms-ship__text');
    if (!nodes.length) return;
    var msg = getMessage();
    for (var i = 0; i < nodes.length; i++) nodes[i].textContent = msg;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }
})();
